import * as z from 'zod';
import { logError } from '../../logging/log-error.helper';
import { baseCustomEventSchemas, } from '../constants/schemas/base-custom-event-schemas.constant';
export function getBaseCustomEvent(_a) {
    var data = _a.data, type = _a.type;
    try {
        return baseCustomEventSchemas[type].parse(data);
    }
    catch (error) {
        logError({
            error: error,
            message: "Validation failed for event: ".concat(type),
            tag: {
                name: 'type-validation',
                value: 'failed',
            },
            level: 'error',
            metadata: {
                event: type,
                data: data,
                validationError: error instanceof z.ZodError ? error.issues : null,
            },
        });
    }
}
